<template>
    <div class="flex-1 relative main-bg-item-light-color px-3 pb-3 pt-4 rounded">
        <div class="overflow-auto wrapper-style flex flex-wrap">
            <WidgetTemplate
                v-for="template in templatesFilteredByLanguageId"
                v-on="$listeners"
                v-bind="$attrs"
                :key="`template-${template.DashboardTemplateID}`"
                :template="template"
                class="template-item m-2"
            />
        </div>
    </div>
</template>
<script>
    import { LAYOUT_TEMPLATES_ALL_LANGUAGES_FILTER_VALUE } from '@/enum/defaultDashboardSettings'

    export default {
        components: {
            WidgetTemplate: () => import('@/views/DashboardCreation/components/Template')
        },
        props: {
            dashboardCategory: {
                type: Object,
                default: () => ({})
            },
            templatesLanguageFilterValue: {
                type: Number,
                default: LAYOUT_TEMPLATES_ALL_LANGUAGES_FILTER_VALUE
            }
        },
        computed: {
            templates () {
                return this.dashboardCategory.DashboardTemplateList || []
            },
            templatesFilteredByLanguageId () {
                if (this.templatesLanguageFilterValue === LAYOUT_TEMPLATES_ALL_LANGUAGES_FILTER_VALUE) {
                    return this.templates
                } else {
                    return this.templates.filter(template => template.LanguageID === this.templatesLanguageFilterValue)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.wrapper-style {
    min-height: 450px;
}
button[disabled] {
    @apply opacity-50 cursor-not-allowed;
}
button:not([disabled]):hover {
    @apply text-primary-200;
}
.template-item {
    width: 350px;
    min-height: 200px;
    height: 100%;
}
</style>
